import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

import Myself from '../../../assets/images/myself.jpeg';
import { careerYearsFormatted } from '../../../utils/yearsOfExperience';
import Reveal from '../../ui/Reveal';

import '../../../styles/About/Route/Intro.scss';

const Intro = () => {
  const totalExp = careerYearsFormatted();

  return (
    <article className="about-intro container">
      <header className="about-intro__header">
        <Reveal as="p" className="about-intro__eyebrow" variant="blur">
          01 — My story
        </Reveal>
        <Reveal as="h1" className="about-intro__title" delay={100}>
          Hello, I&apos;m <span className="gradient-text">Darshan</span>.
        </Reveal>
      </header>

      <div className="about-intro__grid">
        <Reveal className="about-intro__photo" variant="zoom" delay={150}>
          <img src={Myself} alt="Darshan Lal" />
        </Reveal>

        <div className="about-intro__body">
          <Reveal as="p" className="about-intro__lead">
            A Software Engineer (React.js, Angular, React Native &amp; Node.js) based in Dubai, UAE.
          </Reveal>
          <Reveal as="p" delay={100}>
            With over <strong>{totalExp} years</strong> of experience, I focus on React.js, Next.js, Angular, React
            Native and Node.js, building reusable components, microfrontends and real-time interfaces. I&apos;m a fast
            learner and comfortable picking up whatever technology a project needs.
          </Reveal>
          <Reveal as="p" delay={150}>
            At <strong>flydubai</strong> I built aviation systems used at the airport every day: migrating the Departure
            Control System from desktop to a web platform (50% faster first load), a Baggage Management System that
            cut baggage-tracing costs by 80%, a multilingual self check-in kiosk, and a mobile boarding app handling
            40+ passengers per minute. I integrated OpenAI APIs to auto-generate flight and incident summaries.
          </Reveal>
          <Reveal as="p" delay={200}>
            Before that I worked across enterprise e-commerce (Microsoft Dynamics 365 Commerce), logistics platforms,
            and SaaS, always with a strong focus on performance, testing, and maintainability. I also build LLM
            features with OpenAI APIs, LangChain and LangGraph, including AI use cases for procurement and baggage
            matching.
          </Reveal>
          <Reveal as="p" delay={250}>
            I&apos;m available immediately and open to relocation, for Frontend Developer, Backend Developer, Full
            Stack or Forward Deployed Engineer roles that value ownership, collaboration, and high-quality engineering.
          </Reveal>
          <Reveal className="about-intro__actions" delay={300}>
            <Link to="/about/experience" className="btn btn--primary">
              See my experience <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
            </Link>
            <Link to="/#contact" className="btn btn--ghost">
              Get in touch
            </Link>
          </Reveal>
        </div>
      </div>
    </article>
  );
};

export default Intro;
